import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="relative w-full bg-ink-soft px-5 py-10 sm:py-14" data-id="element-135" data-mp="20l3flrbkdyev">
      <div className="mx-auto max-w-xl text-center" data-id="element-136" data-mp="24n85ceyw6aw8">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-aqua/10 ring-1 ring-aqua/40" data-id="element-137" data-mp="24mexfao75fci">
          <ShieldCheckIcon className="h-8 w-8 text-aqua" aria-hidden="true" data-id="element-138" data-mp="29g1av526pn9d" />
        </div>
        <h2 className="mt-5 font-display text-2xl text-lime sm:text-4xl" data-id="element-139" data-mp="2ecrqjra2ugu9">
          Garantía 7 Días — Sin Preguntas
        </h2>
        <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-140" data-mp="2ob7h9t56zo38">
          Probá los tomos. Si no es lo que esperabas, te devolvemos el 100%, sin formularios ni drama.
        </p>
      </div>
    </section>;
}